import { render, staticRenderFns } from "./CpptRanapPage.vue?vue&type=template&id=02fe8b65&scoped=true&"
import script from "./CpptRanapPage.vue?vue&type=script&lang=ts&"
export * from "./CpptRanapPage.vue?vue&type=script&lang=ts&"
import style0 from "./CpptRanapPage.vue?vue&type=style&index=0&id=02fe8b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe8b65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCol,VContainer,VIcon,VRow,VTab,VTabItem,VTabs})
